import { useState, type ReactNode } from "react";

export function Expander({
  head,
  body,
  defaultOpen,
}: {
  head: ReactNode;
  body: ReactNode;
  defaultOpen?: boolean;
}) {
  const [open, setOpen] = useState(!!defaultOpen);
  return (
    <div className={`exp${open ? " is-open" : ""}`}>
      <button
        className="exp-h"
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="exp-t">{head}</span>
        <span className="exp-i" aria-hidden="true">
          i
        </span>
      </button>
      <div className="exp-b">
        <div className="exp-inner">
          <div className="exp-text">{body}</div>
        </div>
      </div>
    </div>
  );
}
